import React from 'react';

import {type SettingType} from '../../../../services/analytics/workspaceSettingsEvents';
import {NumberRangeInput} from '../components/NumberRangeInput';
import {SettingLabel} from '../components/SettingLabel';
import {SettingLogToggle} from '../components/SettingLogToggle';
import {type LinePlotSettings, type SettingLevel} from '../types';
export const XAxisRange = ({
  disabled,
  trackSetting,
  settingLevel,
  updateSetting,
  xAxisMax,
  xAxisMin,
  xLogScale,
  labelRequired,
}: {
  disabled?: boolean;
  trackSetting: (setting: SettingType, value: string | undefined) => void;
  settingLevel: SettingLevel;
  updateSetting: (settings: Partial<LinePlotSettings>) => void;
  xAxisMax?: number;
  xAxisMin?: number;
  xLogScale: boolean;
  labelRequired: boolean;
}) => {
  return (
    <div className="flex" data-test="x-axis-range">
      {labelRequired ? (
        <SettingLabel text="Range" className="ml-14 w-[87px]" />
      ) : null}
      <div className="flex gap-8">
        <NumberRangeInput
          clearValue={settingLevel === 'section' ? null : undefined}
          minField="xAxisMin"
          maxField="xAxisMax"
          minValue={xAxisMin}
          maxValue={xAxisMax}
          updateSetting={updateSetting}
          trackSetting={trackSetting}
        />
        {settingLevel !== 'report' && (
          <SettingLogToggle
            id="xLogScaleToggle"
            className="ml-8"
            isChecked={xLogScale}
            onCheckedChange={newValue => {
              updateSetting({xLogScale: newValue});
            }}
          />
        )}
      </div>
    </div>
  );
};
